import { getCurrentContractAddresses } from "src/configs/address";
import ABI from "src/contract-logic/abis/NFTManagerABI.json";
import { handleEmit } from "src/contract-logic/logic";
import { listenEvent } from "src/utils/multicall";
import { getWeb3Sender, web3Reader } from "src/wallet-connection";

const { NFT_MANAGER_ADDRESS } = getCurrentContractAddresses();
var contractReader = null;
var contractSender = null;

function getContractReader() {
  if (!contractReader) contractReader = new web3Reader.eth.Contract(ABI, NFT_MANAGER_ADDRESS);
  if (!contractReader) throw new Error("Failed to create nft-manager contract reader");
  return contractReader;
}

function getContractSender() {
  const web3Sender = getWeb3Sender();
  if (!contractSender) contractSender = new web3Sender.eth.Contract(ABI, NFT_MANAGER_ADDRESS);
  if (!contractSender) throw new Error("Failed to create nft-manager contract sender");
  return contractSender;
}

async function mintChest(dispatch, toAddress, option, accountAddress) {
  if (![0, 1, 2].includes(option)) throw new Error("Invalid option: accept only 0, 1 or 2");
  const emit = getContractSender().methods.mint(toAddress, option).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Buy Chest");
  await emit;
}

async function openChest(dispatch, tokenId, accountAddress) {
  const emit = getContractSender().methods.openChest(tokenId).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Open Chest");
  await emit;
}

async function tradeUpNft(dispatch, tokenIds, type, rarity, accountAddress) {
  const emit = getContractSender()
    .methods.tradeUp(tokenIds, type, rarity)
    .send({ from: accountAddress, gas: 1000000, gasPrice: 10000000000 });
  handleEmit(dispatch, emit, "Trade Up NFT");
  const res = await emit;
  if (res["logs"]) {
    const failedEvent = res["logs"].find(
      (_log) => _log["topics"][0].toLowerCase() == "0x382d6a8ab2fcecea6a997b1a6fee78195639e559db41d1c2d3a494f915b7d9d4"
    );
    if (failedEvent) {
      const transaction = web3Reader.eth.abi.decodeLog(
        [
          {
            indexed: false,
            internalType: "uint256[]",
            name: "tokenIds",
            type: "uint256[]",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "tokenBurned",
            type: "uint256",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "tokenType",
            type: "uint256",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "tokenRarity",
            type: "uint256",
          },
        ],
        failedEvent.data,
        ["0x382d6a8ab2fcecea6a997b1a6fee78195639e559db41d1c2d3a494f915b7d9d4"]
      );
      return { status: "failed", tokenBurned: parseInt(transaction.tokenBurned) };
    } else {
      const successEvent = res["logs"].find(
        (_log) =>
          _log["topics"][0].toLowerCase() == "0x75d72ff3c1f92b1985b6585082ae998e3ac04fa2022899a3c0cefffe11653461"
      );
      const transaction = web3Reader.eth.abi.decodeLog(
        [
          {
            indexed: false,
            internalType: "uint256[]",
            name: "tokenIds",
            type: "uint256[]",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "tokenTradedUp",
            type: "uint256",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "tokenType",
            type: "uint256",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "tokenRarity",
            type: "uint256",
          },
        ],
        successEvent.data,
        ["0x75d72ff3c1f92b1985b6585082ae998e3ac04fa2022899a3c0cefffe11653461"]
      );
      return { status: "success", tokenTradedUp: parseInt(transaction.tokenTradedUp) };
    }
  }
  throw new Error("Event not found");
}

async function getRelativeFailPercent(tokenIds, rarity) {
  const res = await getContractReader().methods.getRelativeFailPercent(tokenIds, rarity).call();
  return parseInt(res);
}

async function getCirculatingLimit() {
  const res = await getContractReader().methods.getCirculatingLimit().call();
  return parseInt(res);
}

async function checkIfChestOpenedAndSet(tokenId) {
  const res = await getContractReader().methods.checkIfChestOpenedAndSet(tokenId).call();
  return res;
}

async function tradeUpSet(dispatch, tokenIds, type, rarity, accountAddress) {
  const emit = getContractSender().methods.tradeUpSet(tokenIds, type, rarity).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Trade up V1 to V2");
  const res = await emit;
  const data = listenEvent(
    "TradeUpCollectionSuccessfully(uint256[],uint256,uint256,uint256)",
    [
      {
        indexed: false,
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenTradedUp",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenType",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenRarity",
        type: "uint256",
      },
    ],
    res["logs"]
  );
  if (data) return { status: "success", tokenId: parseInt(data["tokenTradedUp"]) };
  else return { status: "fail" };
}

export default {
  ABI,
  ADDRESS: NFT_MANAGER_ADDRESS,
  mintChest,
  openChest,
  tradeUpNft,
  getCirculatingLimit,
  getRelativeFailPercent,
  checkIfChestOpenedAndSet,
  tradeUpSet,
};
